import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';

const useStyles = makeStyles((theme) => ({
  transacao: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    // color: '#0039cb',
    // backgroundColor: '#0039cb',
  },
}));

const StatusField = (props) => {
  const classes = useStyles();
  const { source } = props;
  const record = useRecordContext(props);
  const value = `${record ? record.record[source] : '#000000'}`;
  return (
    <Avatar
      className={classes.transacao}
      style={{ color: value, backgroundColor: value }}
    />
  );
};

export default StatusField;
